'use client'
import { useIndustriesNavbarScroll } from '@/Hooks'
import React from 'react'
import IndHeroSection from './components/IndHeroSection'
import IndSectionTwo from './components/IndSectionTwo'
import MaximizeEfficiency from './components/MaximizeEfficiency'
import WhoCanBenefit from './components/WhoCanBenefit'
import GovernmentFromStrategy from './components/GovernmentFromStrategy'
import GovernmentWhyChoose from './components/GovernmentWhyChoose'
import {
   ContactUsForm,
   FAQs,
   GameChangingIdea,
   WordsOfAppreciation,
} from '@/components'

const faqData = [
   {
      question:
         'What are the major advantages of government and public sector software solutions?',
      answer:
         'Government software solutions enhance process efficiency, public service automation, citizen participation, and regulatory compliance, resulting in transparent and better governance.',
   },
   {
      question:
         'How can digital transformation improve public sector services?',
      answer:
         'Cloud-based service delivery, secure data management, automation, and AI-powered decision-making are all made possible by digital change, which guarantees quicker, easier, and citizen-centric governance.',
   },
   {
      question:
         'What security measures do you implement in government software?',
      answer:
         'We use end-to-end encryption, multi-factor authentication, safe identity verification, blockchain-based records, and compliance with GDPR, CCPA, and other governmental regulations.',
   },
   {
      question:
         'Can government software integrate with existing legacy systems?',
      answer:
         'Yes, we build solutions that perfectly integrate with public APIs, existing databases, legacy systems, and third-party services while maintaining data integrity and hassle-free migration.',
   },
   {
      question:
         'How long does it take to develop a government or public sector platform?',
      answer:
         'The development time varies based on the complexity and features needed. Simple solutions can take a few months, whereas big public sector AI-based platforms can take more time.',
   },
   {
      question:
         'What technologies are used in government software development?',
      answer:
         'We apply AI, blockchain, IoT, cloud computing, big data analytics, and automation tools to make public sector solutions more efficient, secure, and scalable.',
   },
   {
      question:
         'Can AI-powered analytics be integrated into government platforms?',
      answer:
         'Yes, we apply AI-driven analytics to monitor public service performance, citizen participation, policy success, and the use of resources, allowing for data-based decision-making.',
   },
   {
      question: 'How do e-government portals enhance public service delivery?',
      answer:
         'In order to reduce paperwork and increase efficiency, e-government portals digitize public services, automate workflows, give self-service choices, and enable real-time service tracking.',
   },
   {
      question:
         'What are the best practices for managing sensitive government data?',
      answer:
         'Best practices involve installing tight access controls, encrypted databases, automated backup, AI-powered fraud detection, and adherence to cybersecurity standards.',
   },
   {
      question:
         'What post-launch support do you provide for public sector software?',
      answer:
         'We provide 24/7 maintenance, security patches, regulatory compliance scans, feature updates, and continuous optimization to provide constant efficiency and security.',
   },
];

function GovernmentAndPublicSectorPage() {
   useIndustriesNavbarScroll()
   return (
      <>
         <IndHeroSection />
         <IndSectionTwo />
         <MaximizeEfficiency />
         <WhoCanBenefit />
         <GovernmentFromStrategy />
         <GovernmentWhyChoose />
         <GameChangingIdea />
         <section className="section appreciation-slider-section page_top_section section_secondary_bg">
            <WordsOfAppreciation />
         </section>
         <FAQs faqsConst={faqData} />

         <ContactUsForm />
      </>
   )
}

export default GovernmentAndPublicSectorPage
